var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5505 2.09845L10.5255 2.15678L8.10879 7.76511H5.73379C5.16712 7.76511 4.62546 7.88178 4.13379 8.09011L5.59212 4.60678L5.62546 4.52345L5.68379 4.39011C5.70046 4.34011 5.71712 4.29011 5.74212 4.24845C6.83379 1.72345 8.06712 1.14845 10.5505 2.09845Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 7.93178C14.6667 7.81511 14.2667 7.76511 13.8667 7.76511H8.1084L10.5251 2.15678L10.5501 2.09845C10.6751 2.14011 10.7917 2.19845 10.9167 2.24845L12.7584 3.02345C13.7834 3.44845 14.5001 3.89011 14.9334 4.42345C15.0167 4.52345 15.0834 4.61511 15.1417 4.72345C15.2167 4.84011 15.2751 4.95678 15.3084 5.08178C15.3417 5.15678 15.3667 5.23178 15.3834 5.29845C15.6084 5.99845 15.4751 6.85678 15.0417 7.93178Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9351 11.832V13.457C17.9351 13.6236 17.9268 13.7903 17.9184 13.957C17.7601 16.8653 16.1351 18.332 13.0518 18.332H6.55176C6.35176 18.332 6.15176 18.3153 5.96009 18.2903C3.31009 18.1153 1.89342 16.6986 1.71842 14.0486C1.69342 13.857 1.67676 13.657 1.67676 13.457V11.832C1.67676 10.157 2.69342 8.7153 4.14342 8.0903C4.64342 7.88197 5.17676 7.7653 5.74342 7.7653H13.8768C14.2851 7.7653 14.6851 7.82363 15.0518 7.93197C16.7101 8.4403 17.9351 9.9903 17.9351 11.832Z",
    fill: "#EC421C",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59199 4.60678L4.13366 8.09011C2.68366 8.71511 1.66699 10.1568 1.66699 11.8318V9.39011C1.66699 7.02345 3.35033 5.04845 5.59199 4.60678Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9322 9.38971V11.8314C17.9322 9.99805 16.7155 8.43971 15.0488 7.93971C15.4822 6.85638 15.6072 6.00638 15.3988 5.29805C15.3822 5.22305 15.3572 5.14805 15.3238 5.08138C16.8738 5.88138 17.9322 7.52305 17.9322 9.38971Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletOrange);
export default __webpack_public_path__ + "static/media/wallet-orange.7d5eea18aa237c220cdeb87ee0e4ff1b.svg";
export { ForwardRef as ReactComponent };